import dateFns from 'date-fns/locale/zh-CN';

export default {
  dateFns,

  format: {
    date: 'M/d/yyyy',
    time: 'p',
    dateTime: '$t(format:date) $t(format:time)',
    longDate: 'MMM d',
    longDateTime: "MMMM d 'at' p",
    fullDate: 'MMM d, y',
    fullDateTime: "MMMM d, y 'at' p",
  },

  translation: {
    common: {
      aboutPlanka: '关于 Planka',
      account: '账号',
      actions: '操作',
      addAttachment_title: '添加附件',
      addComment: '添加评论',
      addManager_title: '添加管理员',
      addMember_title: '添加成员',
      addUser_title: '添加用户',
      administrator: '管理员',
      all: '全部',
      allChangesWillBeAutomaticallySavedAfterConnectionRestored: '所有修改会在重连后自动保存',
      areYouSureYouWantToDeleteThisAttachment: '确认删除此附件吗？',
      areYouSureYouWantToDeleteThisBoard: '确认删除此面板吗？',
      areYouSureYouWantToDeleteThisCard: '确认删除此卡片吗？',
      areYouSureYouWantToDeleteThisComment: '确认删除此评论吗？',
      areYouSureYouWantToDeleteThisLabel: '确认删除此标签吗？',
      areYouSureYouWantToDeleteThisList: '确认删除此列表吗？',
      areYouSureYouWantToDeleteThisProject: '确认删除此项目吗？',
      areYouSureYouWantToDeleteThisTask: '确认删除此任务吗？',
      areYouSureYouWantToDeleteThisUser: '确认删除此用户吗？',
      areYouSureYouWantToLeaveBoard: '确认离开此面板吗？',
      areYouSureYouWantToLeaveProject: '确认离开此项目吗？',
      areYouSureYouWantToRemoveThisManagerFromProject: '确认从本项目删除该管理员吗？',
      areYouSureYouWantToRemoveThisMemberFromBoard: '确认本面板删除该成员吗？',
      attachment: '附件',
      attachments: '多个附件',
      authentication: '认证',
      background: '背景',
      board: '面板',
      boardNotFound_title: '面板不存在',
      canComment: '可以评论',
      canEditContentOfBoard: '可以编辑面板内容',
      canOnlyViewBoard: '仅可查看面板',
      cardActions_title: '卡片操作',
      cardNotFound_title: '卡片不存在',
      cardOrActionAreDeleted: '卡片或操作已经被删除',
      color: '颜色',
      createBoard_title: '创建面板',
      createLabel_title: '创建标签',
      createNewOneOrSelectExistingOne: '创建一个新的或者选择一个已创建的',
      createProject_title: '创建项目',
      createTextFile_title: '创建文本文件',
      currentPassword: '当前密码',
      dangerZone_title: '危险区域',
      date: '日期',
      dueDate_title: '截止日期',
      deleteAttachment_title: '删除附件',
      deleteBoard_title: '删除面板',
      deleteCard_title: '删除卡片',
      deleteComment_title: '删除评论',
      deleteLabel_title: '删除标签',
      deleteList_title: '删除列表',
      deleteProject_title: '删除项目',
      deleteTask_title: '删除任务',
      deleteUser_title: '删除用户',
      description: '描述',
      detectAutomatically: '自动检测',
      dropFileToUpload: '拖放文件以上传',
      editor: '编辑器',
      editAttachment_title: '编辑附件',
      editAvatar_title: '编辑头像',
      editBoard_title: '编辑面板',
      editDueDate_title: '编辑截止时间',
      editEmail_title: '编辑邮箱',
      editInformation_title: '编辑信息',
      editLabel_title: '编辑标签',
      editPassword_title: '修改密码',
      editPermissions_title: '修改权限',
      editStopwatch_title: '修改时间',
      editUsername_title: '修改用户名',
      email: '邮箱',
      emailAlreadyInUse: '邮箱已使用',
      enterCardTitle: '输入卡片标题...',
      enterDescription: '输入描述...',
      enterFilename: '输入文件名',
      enterListTitle: '输入列表标题...',
      enterProjectTitle: '输入项目标题',
      enterTaskDescription: '输入任务描述...',
      filterByLabels_title: '通过标签筛选',
      filterByMembers_title: '通过成员筛选',
      fromComputer_title: '来自计算机',
      fromTrello: '来自 Trello',
      general: '全体',
      hours: '小时',
      importBoard_title: '导入面板',
      invalidCurrentPassword: '当前密码错误',
      labels: '标签',
      language: '语言',
      leaveBoard_title: '离开面板',
      leaveProject_title: '离开项目',
      list: '列表',
      listActions_title: '列表操作',
      managers: '管理员',
      members: '成员',
      minutes: '分钟',
      moveCard_title: '移动卡片',
      name: '姓名',
      newEmail: '新邮箱',
      newPassword: '新密码',
      newUsername: '新用户名',
      noConnectionToServer: '未连接服务器',
      noBoards: '没有面板',
      noLists: '没有列表',
      noProjects: '没有项目',
      notifications: '通知',
      noUnreadNotifications: '没有未读通知',
      openBoard_title: '打开面板',
      optional_inline: '可选的',
      organization: '组织机构',
      phone: '电话',
      preferences: '偏好',
      pressPasteShortcutToAddAttachmentFromClipboard:
        '提示: 按下 Ctrl-V (Mac: Cmd-V) 从剪切板添加附件',
      project: '项目',
      projectNotFound_title: '项目未找到',
      removeManager_title: '删除管理员',
      removeMember_title: '删除成员',
      searchLabels: '搜索标签...',
      searchMembers: '搜索成员...',
      searchUsers: '搜索用户...',
      seconds: '秒',
      selectBoard: '选择面板',
      selectList: '选择列表',
      selectPermissions_title: '选择权限',
      selectProject: '选择项目',
      settings: '设置',
      stopwatch: '计时器',
      subscribeToMyOwnCardsByDefault: '默认关注自己创建的卡片',
      taskActions_title: '任务操作',
      tasks: '任务',
      thereIsNoPreviewAvailableForThisAttachment: '此附件无法预览',
      time: '时间',
      title: '标题',
      userActions_title: '用户操作',
      userAddedThisCardToList: '<0>{{user}}</0><1> 向列表 {{list}} 添加了该卡片</1>',
      userLeftNewCommentToCard: '{{user}} 给 {{card}} 添加了一个新评论 «{{comment}}»',
      userMovedCardFromListToList:
        '{{user}} 将卡片 <2>{{card}}</2> 从 {{fromList}} 移动到 {{toList}}',
      userMovedThisCardFromListToList:
        '<0>{{user}}</0><1> 将该卡片从 {{fromList}} 移动到 {{toList}}</1>',
      username: '用户名',
      usernameAlreadyInUse: '用户名已被占用',
      users: '用户',
      version: '版本',
      viewer: '视图',
      writeComment: '编写评论...',
    },

    action: {
      addAnotherCard: '添加别的卡片',
      addAnotherList: '添加别的列表',
      addAnotherTask: '添加别的任务',
      addCard: '添加卡片',
      addCard_title: '添加卡片',
      addComment: '添加评论',
      addList: '添加列表',
      addMember: 'Add member',
      addMoreDetailedDescription: '添加更多详细描述',
      addTask: '添加任务',
      addToCard: '添加到卡片',
      addUser: '添加用户',
      createBoard: '创建面板',
      createFile: '创建文件',
      createLabel: '创建标签',
      createNewLabel: '创建新标签',
      createProject: '创建项目',
      delete: '删除',
      deleteAttachment: '删除附件',
      deleteAvatar: '删除头像',
      deleteBoard: '删除面板',
      deleteCard: '删除卡片',
      deleteCard_title: '删除卡片',
      deleteComment: '删除评论',
      deleteImage: '删除图片',
      deleteLabel: '删除标签',
      deleteList: '删除列表',
      deleteList_title: '删除列表',
      deleteNotifications: 'Dismiss all',
      deleteProject: '删除项目',
      deleteProject_title: '删除项目',
      deleteTask: '删除任务',
      deleteTask_title: '删除任务',
      deleteUser: '删除用户',
      edit: '编辑',
      editDueDate_title: '编辑到期时间',
      editDescription_title: '编辑描述',
      editEmail_title: '编辑邮箱',
      editInformation_title: '编辑信息',
      editPassword_title: '编辑密码',
      editPermissions: '编辑权限',
      editStopwatch_title: '编辑时间',
      editTitle_title: '编辑标题',
      editUsername_title: '编辑用户名',
      hideDetails: '隐藏详情',
      import: '导入',
      leaveBoard: '离开面板',
      leaveProject: '离开项目',
      logOut_title: '退出',
      makeCover_title: '设置标题',
      move: '移动',
      moveCard_title: '移动卡片',
      remove: '删除',
      removeBackground: '删除背景',
      removeCover_title: '删除封面',
      removeFromBoard: '从面板中删除',
      removeFromProject: '从项目中删除',
      removeManager: '删除管理者',
      removeMember: '删除成员',
      save: '保存',
      showAllAttachments: '显示所有的附件 ({{hidden}} 隐藏)',
      showDetails: '显示详情',
      showFewerAttachments: '显示较少的附件',
      start: '开始',
      stop: '结束',
      subscribe: '关注',
      unsubscribe: '取消关注',
      uploadNewAvatar: '上传新头像',
      uploadNewImage: '上传图片',
    },
  },
};
